import { ArticleHeading4, Button, IconReload16, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubAgentsError.css';

type TSubAgentsError = {
  onClick: () => void;
};

export const SubAgentsError: React.FC<TSubAgentsError> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <ArticleHeading4>Список сотрудников не загрузился</ArticleHeading4>
        <UIText1 color="gray60_100">Попробуйте обновить</UIText1>
      </div>
      <Button size="XS" theme="stroke_primary" onClick={onClick} beforeIcon={<IconReload16 color="primary_100" />}>
        Обновить
      </Button>
    </div>
  );
};
